var _defs, _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _rect, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _rect2, _rect3, _path157, _path158, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _rect20, _rect21, _rect22, _rect23, _rect24, _path169, _rect25, _rect26, _rect27, _path170;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewAndShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1736",
    "data-name": "Group 1736",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 471.518,
    height: 391.333,
    viewBox: "0 0 471.518 391.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2006",
    "data-name": "Rectangle 2006",
    width: 471.518,
    height: 391.333,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M29.674,199.224a175,175,0,1,0,175-175,175,175,0,0,0-175,175",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2026",
    "data-name": "Rectangle 2026",
    width: 298.967,
    height: 12.524,
    transform: "translate(0 286.568)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2027",
    "data-name": "Rectangle 2027",
    width: 169.795,
    height: 12.525,
    transform: "translate(233.268 334.033)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2028",
    "data-name": "Rectangle 2028",
    width: 277.09,
    height: 159.84,
    transform: "translate(29.67 126.213)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M379.172,199.224a175,175,0,1,1-175-175,175,175,0,0,1,175,175",
    fill: "#9eb0f6"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2007",
    "data-name": "Rectangle 2007",
    width: 454.543,
    height: 147.884,
    transform: "translate(14.612 243.449)",
    fill: "#d6d2a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    width: 454.543,
    height: 253.76,
    transform: "translate(16.975 -0.001)",
    fill: "#cba88c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2009",
    "data-name": "Rectangle 2009",
    width: 3.995,
    height: 151.327,
    transform: "translate(72.784 96.156)",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M106.437,99.215H43.124a1.1,1.1,0,0,1-.993-1.568l18.96-40.056a1.1,1.1,0,0,1,.992-.629H87.478a1.1,1.1,0,0,1,.992.629l18.96,40.056a1.1,1.1,0,0,1-.993,1.568m-61.579-2.2H104.7L86.783,59.158h-24Z",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M81.321,82.023a6.541,6.541,0,0,0-13.081,0c0,1.406.991,3.629,2.2,5.82a6.615,6.615,0,0,1,.826,3.2v7.468h7.027V91.041a6.615,6.615,0,0,1,.826-3.2c1.21-2.191,2.2-4.414,2.2-5.82",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M194.27,120.04H162.758a1.1,1.1,0,0,1-1.1-1.1V80.806a1.1,1.1,0,0,1,1.1-1.1H194.27a1.1,1.1,0,0,1,1.1,1.1v38.136a1.1,1.1,0,0,1-1.1,1.1m-30.414-2.2h29.315V81.9H163.856Z",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M152.067,143.586H120.556a1.1,1.1,0,0,1-1.1-1.1V104.352a1.1,1.1,0,0,1,1.1-1.1h31.511a1.1,1.1,0,0,1,1.1,1.1v38.137a1.1,1.1,0,0,1-1.1,1.1m-30.413-2.2h29.315V105.45H121.654Z",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M238.074,101.234H206.563a1.1,1.1,0,0,1-1.1-1.1V62a1.1,1.1,0,0,1,1.1-1.1h31.511a1.1,1.1,0,0,1,1.1,1.1v38.136a1.1,1.1,0,0,1-1.1,1.1m-30.413-2.2h29.316V63.1H207.661Z",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2010",
    "data-name": "Rectangle 2010",
    width: 14.091,
    height: 10.403,
    transform: "translate(171.446 108.539)",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M178.245,109.637a1.1,1.1,0,0,1-.706-.258,26.9,26.9,0,0,1-8.907-24.531,1.1,1.1,0,0,1,1.788-.649,26.91,26.91,0,0,1,8.906,24.531,1.1,1.1,0,0,1-1.081.907m-7.662-22.2a24.3,24.3,0,0,0,6.793,18.71,24.313,24.313,0,0,0-6.793-18.71",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M179.108,109.34a1.1,1.1,0,0,1-1.081-.907,19.954,19.954,0,0,1,6.607-18.2,1.1,1.1,0,0,1,1.788.649,19.949,19.949,0,0,1-6.608,18.2,1.1,1.1,0,0,1-.706.258m5.329-15.772a17.276,17.276,0,0,0-4.425,12.179,17.284,17.284,0,0,0,4.425-12.179m-4.43,5.285h0Z",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M222.318,100.628a10.156,10.156,0,0,1-5.3-18.818V70.443a1.1,1.1,0,0,1,1.1-1.1h8.408a1.1,1.1,0,0,1,1.1,1.1V81.81a10.156,10.156,0,0,1-5.3,18.818m-3.106-29.087V82.448a1.1,1.1,0,0,1-.588.972,7.961,7.961,0,1,0,7.387,0,1.1,1.1,0,0,1-.587-.972V71.541Z",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M142.619,143.28H127.554a1.1,1.1,0,0,1-1.085-1.264l1.294-8.45a47.7,47.7,0,0,0-1.265-20.36,1.1,1.1,0,0,1,1.056-1.4h10.957a1.1,1.1,0,0,1,1.087.946l4.108,29.274a1.1,1.1,0,0,1-1.087,1.251m-13.786-2.2h12.524L137.556,114h-8.571a49.828,49.828,0,0,1,.948,19.893Z",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M141.4,133.865a1.1,1.1,0,0,1-1.054-1.41l3.533-11.92a2.285,2.285,0,0,0-2.19-2.933h-2.669a1.1,1.1,0,0,1,0-2.2h2.669a4.48,4.48,0,0,1,4.295,5.753l-3.533,11.92a1.1,1.1,0,0,1-1.051.786",
    fill: "#9ceded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M341.494,94.256h-.039a.549.549,0,0,1-.509-.587l2.713-38.319a.555.555,0,0,1,.586-.509.548.548,0,0,1,.509.586l-2.713,38.32a.55.55,0,0,1-.547.51",
    fill: "#fff35c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M343.175,94.233a.487.487,0,0,1-.085-.007.548.548,0,0,1-.458-.626l2.63-16.881a.549.549,0,1,1,1.085.169l-2.63,16.881a.55.55,0,0,1-.542.464",
    fill: "#fffbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M343.2,63.726l7.058-15.38a.243.243,0,0,1,.463.077l.367,3.493a.866.866,0,0,1-.148.58Z",
    fill: "#fff35c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M342.7,70.612,351.736,56.3a.243.243,0,0,1,.449.137l-.1,3.511a.862.862,0,0,1-.223.556Z",
    fill: "#fff35c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M343.858,56.751l5.336-16.058a.242.242,0,0,1,.467.025l.747,3.432a.861.861,0,0,1-.084.593Z",
    fill: "#fff35c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M343.858,64.16,336.8,48.781a.243.243,0,0,0-.463.076l-.366,3.493a.859.859,0,0,0,.147.58Z",
    fill: "#fff35c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M343.062,70.387l-9.035-14.308a.243.243,0,0,0-.449.137l.1,3.511a.868.868,0,0,0,.223.556Z",
    fill: "#fff35c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M344.276,56.751,338.94,40.693a.243.243,0,0,0-.468.025l-.746,3.432a.861.861,0,0,0,.083.593Z",
    fill: "#fff35c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M337.494,94.233a.548.548,0,0,1-.548-.526l-1.179-28.515a.549.549,0,0,1,1.1-.046l1.178,28.515a.549.549,0,0,1-.526.571h-.023",
    fill: "#fff4b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M336.316,73.58,329.258,58.2a.243.243,0,0,0-.463.076l-.367,3.493a.864.864,0,0,0,.148.58Z",
    fill: "#fff4b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M336.316,79.59l-9.035-14.308a.243.243,0,0,0-.449.137l.1,3.511a.862.862,0,0,0,.223.556Z",
    fill: "#fff4b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M336.316,65.819,330.98,49.76a.243.243,0,0,0-.468.025l-.746,3.433a.861.861,0,0,0,.083.593Z",
    fill: "#fff4b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M336.316,73.58,343.374,58.2a.243.243,0,0,1,.463.076l.367,3.493a.864.864,0,0,1-.148.58Z",
    fill: "#fff4b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M336.316,79.59l9.035-14.308a.243.243,0,0,1,.449.137l-.1,3.511a.862.862,0,0,1-.223.556Z",
    fill: "#fff4b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M336.316,65.819l5.336-16.059a.243.243,0,0,1,.468.025l.746,3.433a.861.861,0,0,1-.083.593Z",
    fill: "#fff4b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M344.938,84.317,337.88,68.938a.243.243,0,0,0-.463.076l-.367,3.493a.864.864,0,0,0,.148.58Z",
    fill: "#fffbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M344.152,89.967l-9.035-14.308a.243.243,0,0,0-.449.137l.1,3.511a.868.868,0,0,0,.223.556Z",
    fill: "#fffbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M345.986,77.351,340.65,61.292a.243.243,0,0,0-.468.025l-.746,3.433a.861.861,0,0,0,.083.593Z",
    fill: "#fffbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M344.631,84.224l8.1-14.858a.243.243,0,0,1,.456.108l.126,3.51a.862.862,0,0,1-.187.569Z",
    fill: "#fffbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M343.858,89.067l11.359-12.542a.244.244,0,0,1,.42.212l-.7,3.442a.869.869,0,0,1-.317.509Z",
    fill: "#fffbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M345.687,78.5l5.336-16.058a.243.243,0,0,1,.468.025l.746,3.432a.866.866,0,0,1-.083.593Z",
    fill: "#fffbd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M346.865,120.448a49.237,49.237,0,0,0-.841-9.284A90.471,90.471,0,0,1,344.28,93.93v-.246H335.3v.246a90.47,90.47,0,0,1-1.743,17.234,49.239,49.239,0,0,0-.841,9.284,43.848,43.848,0,0,0,1.815,13.118H345.05a43.847,43.847,0,0,0,1.815-13.118",
    fill: "#ffd2d0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2011",
    "data-name": "Rectangle 2011",
    width: 39.871,
    height: 1.098,
    transform: "translate(337.399 133.371) rotate(-84.882)",
    fill: "#ffb5b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2012",
    "data-name": "Rectangle 2012",
    width: 1.098,
    height: 39.882,
    transform: "translate(336.945 93.684)",
    fill: "#ffb5b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2013",
    "data-name": "Rectangle 2013",
    width: 40.463,
    height: 1.098,
    transform: "translate(335.81 133.475) rotate(-80.298)",
    fill: "#ffb5b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M345.049,134.3H334.533a.732.732,0,0,1-.7-.506,44.769,44.769,0,0,1-1.851-13.345,50.444,50.444,0,0,1,.855-9.423,90.069,90.069,0,0,0,1.731-17.1v-.245a.731.731,0,0,1,.731-.732h8.977a.732.732,0,0,1,.732.732v.246a90.143,90.143,0,0,0,1.73,17.094,50.363,50.363,0,0,1,.854,9.423,44.769,44.769,0,0,1-1.851,13.345.732.732,0,0,1-.7.506m-9.977-1.464h9.439a44.13,44.13,0,0,0,1.621-12.387,48.917,48.917,0,0,0-.827-9.144,92.048,92.048,0,0,1-1.756-16.888h-7.516a91.956,91.956,0,0,1-1.755,16.888,48.833,48.833,0,0,0-.827,9.144,44.13,44.13,0,0,0,1.621,12.387",
    fill: "#ff908b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M336.521,128.248a.732.732,0,0,1-.724-.631,52.1,52.1,0,0,1-.48-7.17,50.366,50.366,0,0,1,.854-9.424c.219-1.127.421-2.267.6-3.388a.732.732,0,0,1,1.445.231c-.181,1.137-.386,2.293-.608,3.436a48.918,48.918,0,0,0-.828,9.145,50.573,50.573,0,0,0,.467,6.968.732.732,0,0,1-.624.826.874.874,0,0,1-.1.007",
    fill: "#ff908b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M346.262,139.544a5.382,5.382,0,0,1,0,9.457h20.8v-9.457Z",
    fill: "#ffd2d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M367.061,149.734h-20.8a.732.732,0,0,1-.35-1.375,4.649,4.649,0,0,0,0-8.171.732.732,0,0,1,.35-1.375h20.8a.732.732,0,0,1,.732.732V149a.732.732,0,0,1-.732.732m-18.742-1.464h18.01v-7.993h-18.01a6.114,6.114,0,0,1,0,7.993",
    fill: "#ff908b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M395.3,144.273a5.38,5.38,0,0,0-2.8-4.723v-.006H367.061V149H392.5V149a5.38,5.38,0,0,0,2.8-4.723",
    fill: "#ffb3af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M392.5,149.734H367.061a.732.732,0,0,1-.732-.732v-9.457a.732.732,0,0,1,.732-.732H392.5a.726.726,0,0,1,.427.138,6.113,6.113,0,0,1-.012,10.653.725.725,0,0,1-.415.13m-24.707-1.464h24.5a4.649,4.649,0,0,0,0-7.993h-24.5Z",
    fill: "#ff908b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M386.735,149.394a.732.732,0,0,1-.732-.732v-9.117a.732.732,0,0,1,1.464,0v9.117a.732.732,0,0,1-.732.732",
    fill: "#ff908b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M383.226,149.733a.732.732,0,0,1-.732-.732v-9.457a.732.732,0,1,1,1.464,0V149a.732.732,0,0,1-.732.732",
    fill: "#ff908b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M311.127,133.566h5.4l-3.55-15.986h-5.4Z",
    fill: "#ffb3af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M316.523,134.3h-5.4a.734.734,0,0,1-.715-.573l-3.55-15.987a.732.732,0,0,1,.715-.89h5.4a.731.731,0,0,1,.714.573l3.55,15.986a.733.733,0,0,1-.714.891m-4.809-1.464h3.9l-3.224-14.522h-3.9Z",
    fill: "#ff908b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M309.111,133.566H290.594l5.893-26.535H315Z",
    fill: "#ffd2d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M306.859,130.027H294.733a.709.709,0,0,1-.692-.862l4.007-18.041a.707.707,0,0,1,.691-.555h12.126a.709.709,0,0,1,.692.862l-4.006,18.041a.709.709,0,0,1-.692.555",
    fill: "#ffb3af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M309.111,134.3H290.6a.733.733,0,0,1-.715-.891l5.893-26.535a.731.731,0,0,1,.714-.573H315a.731.731,0,0,1,.714.89l-5.893,26.536a.732.732,0,0,1-.714.573m-17.6-1.464h17.017l5.568-25.071H297.075Z",
    fill: "#ff908b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2014",
    "data-name": "Rectangle 2014",
    width: 97.742,
    height: 119.52,
    transform: "translate(303.908 134.584)",
    fill: "#f5dead"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2015",
    "data-name": "Rectangle 2015",
    width: 97.742,
    height: 29.959,
    transform: "translate(303.908 134.584)",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M330.064,174.017H305.89a.549.549,0,0,1-.549-.549v-9.809a.549.549,0,0,1,.549-.549h24.174a.549.549,0,0,1,.549.549v9.809a.549.549,0,0,1-.549.549m-23.625-1.1h23.076v-8.712H306.439Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M358.85,174.017H334.676a.549.549,0,0,1-.549-.549v-9.809a.549.549,0,0,1,.549-.549H358.85a.549.549,0,0,1,.549.549v9.809a.549.549,0,0,1-.549.549m-23.625-1.1H358.3v-8.712H335.225Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M387.636,174.017H363.462a.549.549,0,0,1-.549-.549v-9.809a.549.549,0,0,1,.549-.549h24.174a.549.549,0,0,1,.549.549v9.809a.549.549,0,0,1-.549.549m-23.625-1.1h23.076v-8.712H364.011Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M387.636,199.261H373.5a.549.549,0,0,1-.549-.549V188.9a.549.549,0,0,1,.549-.549h14.132a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-13.583-1.1h13.034v-8.712H374.053Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M392.654,212.585H380.94a.549.549,0,0,1-.549-.549v-9.81a.549.549,0,0,1,.549-.549h11.714a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-11.165-1.1h10.617v-8.712H381.489Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M387.636,225.908H373.5a.549.549,0,0,1-.549-.549v-9.81A.549.549,0,0,1,373.5,215h14.132a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-13.583-1.1h13.034V216.1H374.053Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M392.654,239.232H380.94a.549.549,0,0,1-.549-.549v-9.81a.549.549,0,0,1,.549-.549h11.714a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-11.165-1.1h10.617v-8.712H381.489Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M320.022,199.261H305.89a.549.549,0,0,1-.549-.549V188.9a.549.549,0,0,1,.549-.549h14.132a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-13.583-1.1h13.034v-8.712H306.439Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M330.21,212.585H314.058a.549.549,0,0,1-.549-.549v-9.81a.549.549,0,0,1,.549-.549H330.21a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-15.6-1.1h15.054v-8.712H314.607Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M320.022,225.908H305.89a.549.549,0,0,1-.549-.549v-9.81a.549.549,0,0,1,.549-.549h14.132a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-13.583-1.1h13.034V216.1H306.439Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M330.21,239.232H314.058a.549.549,0,0,1-.549-.549v-9.81a.549.549,0,0,1,.549-.549H330.21a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-15.6-1.1h15.054v-8.712H314.607Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M322.873,186.662H298.7a.549.549,0,0,1-.549-.549V176.3a.549.549,0,0,1,.549-.549h24.174a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-23.625-1.1h23.076v-8.712H299.248Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M351.659,186.662H327.485a.549.549,0,0,1-.549-.549V176.3a.549.549,0,0,1,.549-.549h24.174a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-23.625-1.1H351.11v-8.712H328.034Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M380.445,186.662H356.271a.548.548,0,0,1-.548-.549V176.3a.548.548,0,0,1,.548-.549h24.174a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-23.625-1.1H379.9v-8.712H356.82Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M322.873,251.864H298.7a.549.549,0,0,1-.549-.549v-9.81a.549.549,0,0,1,.549-.549h24.174a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-23.625-1.1h23.076v-8.712H299.248Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M351.659,251.864H327.485a.549.549,0,0,1-.549-.549v-9.81a.549.549,0,0,1,.549-.549h24.174a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-23.625-1.1H351.11v-8.712H328.034Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M380.445,251.864H356.271a.548.548,0,0,1-.548-.549v-9.81a.548.548,0,0,1,.548-.549h24.174a.549.549,0,0,1,.549.549v9.81a.549.549,0,0,1-.549.549m-23.625-1.1H379.9v-8.712H356.82Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M362.445,196.491a32.237,32.237,0,0,1,14.989,3.673v-8.315a2.945,2.945,0,0,0-2.946-2.947H327.427a2.944,2.944,0,0,0-2.946,2.947V235.77a2.944,2.944,0,0,0,2.946,2.946h4.162a32.4,32.4,0,0,1,30.856-42.225",
    fill: "#6a3225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M377.434,235.77V200.165a32.395,32.395,0,0,0-45.845,38.551h42.9a2.944,2.944,0,0,0,2.946-2.946",
    fill: "#844031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M362.445,196.491a32.589,32.589,0,0,1,4.566.322v-4.964a2.945,2.945,0,0,0-2.946-2.947H327.427a2.944,2.944,0,0,0-2.946,2.947V235.77a2.944,2.944,0,0,0,2.946,2.946h4.162a32.4,32.4,0,0,1,30.856-42.225",
    fill: "#5b271d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M367.011,235.77V196.814a32.4,32.4,0,0,0-35.422,41.9h32.476a2.944,2.944,0,0,0,2.946-2.946",
    fill: "#773528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M337.919,206.782a.114.114,0,0,0-.131.171c.783,1.16,3.757,5.809,3.757,9.491,0,2.947-2,5.328-2.559,8.138a9.81,9.81,0,0,0,2.245,8.147,9.624,9.624,0,0,0,8.046,3.194,9.364,9.364,0,0,0,7.2-4.777c1.58-2.935,1.406-6.44.724-9.6-.686-3.178-2.338-6.121-2.338-9.44,0-4.087,3.015-7.149,4.33-8.29a.113.113,0,0,0-.118-.189c-1.874.808-6.826,3.148-7.876,5.716a.112.112,0,0,1-.215-.04l-.442-10a.113.113,0,0,0-.212-.049c-.932,1.768-4.911,9.478-4.867,12.131a.112.112,0,0,1-.193.083,18.836,18.836,0,0,0-7.348-4.686",
    fill: "#ff4300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M348.394,236.785a10.418,10.418,0,0,1-10.209-12.363,17.117,17.117,0,0,1,1.266-3.557,11.05,11.05,0,0,0,1.276-4.42c0-3.926-3.754-9.236-3.792-9.289a.818.818,0,0,1,.9-1.257,19.418,19.418,0,0,1,7.006,4.034c.85-3.691,4.175-9.985,4.954-11.432a.819.819,0,0,1,1.539.391l.369,8.336c2.463-2.529,7.108-4.4,7.786-4.663a.818.818,0,0,1,.777,1.425c-.046.034-4.592,3.38-4.592,8.115a17.918,17.918,0,0,0,1.268,5.715,32.643,32.643,0,0,1,1.05,3.552c.9,4.164.637,7.488-.8,10.162a10.14,10.14,0,0,1-7.836,5.2q-.482.048-.965.048m-8.763-28.42c1.193,2.075,2.733,5.293,2.733,8.08a12.462,12.462,0,0,1-1.417,5.083,15.607,15.607,0,0,0-1.158,3.214,9.027,9.027,0,0,0,2.057,7.448,8.778,8.778,0,0,0,7.35,2.919,8.6,8.6,0,0,0,6.558-4.351c1.247-2.316,1.458-5.273.644-9.041a31.621,31.621,0,0,0-1-3.374,19.414,19.414,0,0,1-1.355-6.238A10.7,10.7,0,0,1,356.121,206c-2.184,1.258-4.13,2.789-4.293,4.116a.819.819,0,0,1-1.633-.087l-.355-8.035c-1.907,3.853-3.788,8.3-3.546,9.563a.819.819,0,0,1-1.425.687,18.247,18.247,0,0,0-5.238-3.878",
    fill: "#ff7c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M351.17,232.843a3.015,3.015,0,0,1-2.826-3.174,3.51,3.51,0,0,1,.263-1.34,6,6,0,0,0,.535-2.5,7.315,7.315,0,0,0-2.738-5.4,3.687,3.687,0,0,1-.322,4.348c-.852.93-2.548,2.668-2.548,4.452a5.228,5.228,0,0,0,9.93,2.287,2.739,2.739,0,0,1-2.294,1.326",
    fill: "#f1f1a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M374.489,239.224H327.427a3.459,3.459,0,0,1-3.455-3.454V191.848a3.459,3.459,0,0,1,3.455-3.454h47.062a3.459,3.459,0,0,1,3.455,3.454V235.77a3.459,3.459,0,0,1-3.455,3.454m-47.062-49.813a2.441,2.441,0,0,0-2.438,2.437V235.77a2.441,2.441,0,0,0,2.438,2.437h47.062a2.441,2.441,0,0,0,2.438-2.437V191.848a2.441,2.441,0,0,0-2.438-2.437Z",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2016",
    "data-name": "Rectangle 2016",
    width: 25.577,
    height: 114.181,
    transform: "translate(389.999 139.923)",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2017",
    "data-name": "Rectangle 2017",
    width: 25.577,
    height: 114.181,
    transform: "translate(401.65 139.923)",
    fill: "#ffefbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M392.126,238.267a2.127,2.127,0,1,0,0,4.254h9.525v-4.254Z",
    fill: "#f8e1af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M425.1,238.267H401.65v4.254H425.1a2.127,2.127,0,0,0,0-4.254",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M427.227,139.923H401.65v-5.339h27.574a1.188,1.188,0,0,1,.9,1.961Z",
    fill: "#ffeab9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M401.65,243.07h-9.525a2.656,2.656,0,0,1-1.892-.784.549.549,0,0,1,.776-.776,1.571,1.571,0,0,0,1.116.462h9.525a.549.549,0,1,1,0,1.1",
    fill: "#e3cc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M425.1,243.07H401.65a.549.549,0,0,1,0-1.1H425.1a1.569,1.569,0,0,0,1.1-.445.549.549,0,1,1,.764.789,2.663,2.663,0,0,1-1.862.754",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018",
    "data-name": "Rectangle 2018",
    width: 25.577,
    height: 114.181,
    transform: "translate(273.122 139.923)",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2019",
    "data-name": "Rectangle 2019",
    width: 25.577,
    height: 114.181,
    transform: "translate(284.774 139.923)",
    fill: "#ffefbe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2020",
    "data-name": "Rectangle 2020",
    width: 12.796,
    height: 82.376,
    transform: "translate(290.692 160.145)",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M275.249,155.891a2.127,2.127,0,0,0,0,4.254h9.525v-4.254Z",
    fill: "#f8e1af"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2021",
    "data-name": "Rectangle 2021",
    width: 12.795,
    height: 82.376,
    transform: "translate(293.095 160.145)",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M308.224,155.891h-23.45v4.254h23.45a2.127,2.127,0,1,0,0-4.254",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M275.249,238.267a2.127,2.127,0,0,0,0,4.254h9.525v-4.254Z",
    fill: "#f8e1af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M308.224,238.267h-23.45v4.254h23.45a2.127,2.127,0,1,0,0-4.254",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2022",
    "data-name": "Rectangle 2022",
    width: 17.653,
    height: 15.968,
    transform: "translate(288.237 139.923)",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2023",
    "data-name": "Rectangle 2023",
    width: 17.653,
    height: 15.968,
    transform: "translate(290.197 139.923)",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M303.909,153.341h-9.771a.549.549,0,0,1-.549-.549v-9.77a.549.549,0,0,1,.549-.549h9.771a.549.549,0,0,1,.549.549v9.77a.549.549,0,0,1-.549.549m-9.222-1.1h8.672v-8.672h-8.672Z",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M273.122,139.923H298.7v-5.339H271.125a1.188,1.188,0,0,0-.9,1.961Z",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M310.351,139.923H284.774v-5.339h27.574a1.188,1.188,0,0,1,.9,1.961Z",
    fill: "#ffeab9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M284.774,160.694H275.25a2.659,2.659,0,0,1-1.893-.784.549.549,0,0,1,.777-.776,1.567,1.567,0,0,0,1.116.462h9.524a.549.549,0,1,1,0,1.1",
    fill: "#e3cc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M284.774,243.07H275.25a2.657,2.657,0,0,1-1.893-.784.549.549,0,0,1,.777-.776,1.567,1.567,0,0,0,1.116.462h9.524a.549.549,0,1,1,0,1.1",
    fill: "#e3cc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M308.224,243.07h-23.45a.549.549,0,0,1,0-1.1h23.45a1.569,1.569,0,0,0,1.1-.445.549.549,0,1,1,.764.789,2.663,2.663,0,0,1-1.862.754",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M296.12,232.356a.549.549,0,0,1-.549-.549V170.859a.549.549,0,1,1,1.1,0v60.948a.549.549,0,0,1-.549.549",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M299.492,235.957a.549.549,0,0,1-.549-.549V164.543a.549.549,0,1,1,1.1,0v70.865a.549.549,0,0,1-.549.549",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M302.865,232.356a.549.549,0,0,1-.55-.549V170.859a.549.549,0,1,1,1.1,0v60.948a.549.549,0,0,1-.548.549",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2024",
    "data-name": "Rectangle 2024",
    width: 91.929,
    height: 25.561,
    transform: "translate(309.721 134.584)",
    fill: "#ffefbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M395.824,152.256H315.547a.549.549,0,0,1-.549-.549v-7.495a.549.549,0,0,1,.549-.549h80.277a.549.549,0,0,1,.549.549v7.495a.549.549,0,0,1-.549.549m-79.728-1.1h79.18v-6.4H316.1Z",
    fill: "#edd9a4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2025",
    "data-name": "Rectangle 2025",
    width: 91.929,
    height: 5.339,
    transform: "translate(309.721 134.584)",
    fill: "#ffeab9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M425.1,155.891H303.908v4.254H425.1a2.127,2.127,0,0,0,0-4.254",
    fill: "#fff4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M425.1,160.694H284.774a.549.549,0,0,1,0-1.1H425.1a1.569,1.569,0,0,0,1.1-.445.549.549,0,1,1,.764.788,2.66,2.66,0,0,1-1.862.755",
    fill: "#edd9a4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M298.967,292.83c0,3.458-66.926,6.262-149.483,6.262S0,296.288,0,292.83s66.926-6.262,149.484-6.262,149.483,2.8,149.483,6.262",
    fill: "#ccc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M403.063,340.3c0,3.458-38.01,6.262-84.9,6.262s-84.9-2.8-84.9-6.262,38.01-6.262,84.9-6.262,84.9,2.8,84.9,6.262",
    fill: "#ccc"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M297.56,200.893a9.189,9.189,0,0,0-3.74.8c-.07-.03-.13-.08-.21-.12l-16.19-6.92-10.98-12.77a8.618,8.618,0,0,0-.91-1.29l-6.13-7.14a8.246,8.246,0,0,0-6.19-2.87l-.08-.09-10.02-2.72v-4.7a14.246,14.246,0,0,0,2.3-1.87,17.465,17.465,0,0,0,7.53-13.21,9.679,9.679,0,0,0,.26-1.68,8.873,8.873,0,0,0-.23-2.47,26.491,26.491,0,0,0-1.09-7.01v-.05a4.948,4.948,0,0,0-5.07-4.82c-.09.01-.18.03-.28.04a5.564,5.564,0,0,0-5.63-5.02l-14.26.28a5.581,5.581,0,0,0-5.17,3.86,6.316,6.316,0,0,1,3.4-4.91l-.27.01a5.98,5.98,0,0,0-5.84,6.07,5.907,5.907,0,0,0,.92,3.05,6.031,6.031,0,0,0,2.27,2.1l-.68,12.73a14.386,14.386,0,0,0,6.88,12.99v5.68c0,.26.01.52.03.77a15.833,15.833,0,0,0-2.19,1.81l-.26-.08,2.42-2.22-12.81-.86.06.05a7.434,7.434,0,0,0-.92-.11,8.887,8.887,0,0,0-.88-.26l-17.7-4.06-.89-.21a4.223,4.223,0,0,0-1.7-.02l-14.03,2.73a7.857,7.857,0,0,0-1.29-3.09c-2.55-3.75-7.91-.26-7.91-.26,4.19-.68,4.53,2.93-1,1.96s-6.83-.01-6.83-.01l.01.02a2.568,2.568,0,0,0-.41.19,2.712,2.712,0,0,0-.72.67,11.235,11.235,0,0,0-1.14.05c-4.95.52-7.95,4.81-7.72,7.43a2.5,2.5,0,0,0,.73,1.67,7.777,7.777,0,0,0-.45,1.48H115.64a10.921,10.921,0,0,0-8.59,0h-5.33a11.36,11.36,0,0,0-6.88,2.32,11.308,11.308,0,0,0-6.87-2.32H71.24l-.65-1.02a5.857,5.857,0,0,0-.37-.5,5.065,5.065,0,0,0-3.93-1.82c-.01,0-.01-.01-.01-.02l-4.85.03a10.8,10.8,0,0,0-.42-1.16l-2-4.38H73.88a18.5,18.5,0,0,1-2.37-9.05v-10.64a14.25,14.25,0,0,0-14.25-14.25H53.7a14.566,14.566,0,0,0-2.3.18l-.17.03a14.278,14.278,0,0,0-11.39,10.74,13.8,13.8,0,0,0-.38,3.3v9.86a21.655,21.655,0,0,1-2.37,9.83H49.3l-.61,5.62-4.49.02c-.21-.01-.42,0-.63.01h-.1a5.042,5.042,0,0,0-4.36,3.22H31.14a175.545,175.545,0,0,0,17.22,101.49h17.3c.09,4.17,1.61,7.39,3.92,7.74,1.82.28,3.71-1.29,5.07-3.91.34,1.97,1.2,3.41,2.53,3.86,2.7.93,6.34-2.49,8.26-7.69H166.1a7.678,7.678,0,0,0-3.01,5.98v.61a1.387,1.387,0,0,0,1.39,1.39h26.1a1.4,1.4,0,0,0,1.4-1.39v-2.22a3.619,3.619,0,0,0-3.08-3.38l-.25-.05.22-.94h11.78a7.678,7.678,0,0,0-3.01,5.98v.61a1.389,1.389,0,0,0,1.4,1.39h26.1a1.387,1.387,0,0,0,1.39-1.39v-2.22a3.609,3.609,0,0,0-3.08-3.38l-.32-.07.22-.92h38.68a5.565,5.565,0,0,0,1.54.22h-.24l1.74,7.85h3.47l1.73-7.85H288.1l1.73,7.85h3.47l1.74-7.85a4.678,4.678,0,0,0,4.61-4.68v-54.48a9.195,9.195,0,0,0-2.09-18.15M103.3,243.573c-.02-.11-.04-.23-.06-.34h.12c-.02.11-.04.23-.06.34m77.7-65.96a2.539,2.539,0,0,0-.3-.67l2.41-.09a11.78,11.78,0,0,0-2.11.76m11.5-1.12.5-.02.05.02Zm75.24,32.21v-.63a4.812,4.812,0,0,0,1.16.63Z",
    fill: "#ccc"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M260.06,250.309H181.712v-55.36A11.384,11.384,0,0,1,193.1,183.566H255.07a11.383,11.383,0,0,1,11.382,11.383v48.967a6.392,6.392,0,0,1-6.392,6.393",
    fill: "#5da64c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M268.527,250.309H190.18v-55.36a11.383,11.383,0,0,1,11.382-11.383h61.975a11.384,11.384,0,0,1,11.383,11.383v48.967a6.393,6.393,0,0,1-6.393,6.393",
    fill: "#77d378"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M175.868,250.309H97.521v-55.36A11.384,11.384,0,0,1,108.9,183.566h61.974a11.383,11.383,0,0,1,11.382,11.383v48.967a6.392,6.392,0,0,1-6.392,6.393",
    fill: "#5da64c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M184.335,250.309H105.988v-55.36a11.383,11.383,0,0,1,11.382-11.383h61.975a11.384,11.384,0,0,1,11.383,11.383v48.967a6.393,6.393,0,0,1-6.393,6.393",
    fill: "#77d378"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M98.07,250.309H19.722a6.392,6.392,0,0,1-6.392-6.393V194.949a11.383,11.383,0,0,1,11.383-11.383H86.687A11.383,11.383,0,0,1,98.07,194.949Z",
    fill: "#5da64c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M106.537,250.309H28.189a6.392,6.392,0,0,1-6.392-6.393V194.949A11.383,11.383,0,0,1,33.18,183.566H95.154a11.383,11.383,0,0,1,11.383,11.383Z",
    fill: "#77d378"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M294.147,285.282H270.752a5.531,5.531,0,0,1-5.531-5.531V221.313a5.531,5.531,0,0,1,5.531-5.531h23.395Z",
    fill: "#5da64c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M302.15,285.282h-7.936a4.681,4.681,0,0,1-4.681-4.681V220.466a4.683,4.683,0,0,1,4.683-4.684h7.934a4.685,4.685,0,0,1,4.685,4.684V280.6a4.686,4.686,0,0,1-4.685,4.685",
    fill: "#80d97e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M298.75,293.126h-1.735l-1.735-7.845h3.47Z",
    fill: "#8c4c3a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M300.484,293.126h-1.735v-7.845h3.47Z",
    fill: "#a25c44"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M273.984,293.126h-1.735l-1.735-7.845h3.47Z",
    fill: "#8c4c3a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M275.719,293.126h-1.735v-7.845h3.47Z",
    fill: "#a25c44"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2029",
    "data-name": "Rectangle 2029",
    width: 234.199,
    height: 31.123,
    transform: "translate(38.505 253.936)",
    fill: "#5a9746"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M100.11,268.372h-60.1A10.547,10.547,0,0,1,29.46,257.824v-5.3a10.547,10.547,0,0,1,10.547-10.547h60.1a10.548,10.548,0,0,1,10.548,10.547v5.3a10.548,10.548,0,0,1-10.548,10.548",
    fill: "#5da64c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M180.958,268.372h-60.1a10.547,10.547,0,0,1-10.547-10.548v-5.3a10.547,10.547,0,0,1,10.547-10.547h60.1a10.548,10.548,0,0,1,10.548,10.547v5.3a10.548,10.548,0,0,1-10.548,10.548",
    fill: "#5da64c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M262.156,268.372h-60.1a10.547,10.547,0,0,1-10.547-10.548v-5.3a10.547,10.547,0,0,1,10.547-10.547h60.1A10.548,10.548,0,0,1,272.7,252.52v5.3a10.548,10.548,0,0,1-10.548,10.548",
    fill: "#5da64c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M272.25,268.715a.318.318,0,0,1-.318-.318v-18.06a7.818,7.818,0,0,0-7.809-7.809h-7.06a.318.318,0,0,1,0-.636h7.06a8.455,8.455,0,0,1,8.445,8.445V268.4a.318.318,0,0,1-.318.318",
    fill: "#5a9746"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M93.1,233.752a.314.314,0,0,1-.18-.056L35.054,193.958a.318.318,0,1,1,.36-.524l57.865,39.738a.318.318,0,0,1,.082.442.314.314,0,0,1-.261.138",
    fill: "#5da64c"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M35.592,234.265a.318.318,0,0,1-.185-.577l57.149-40.763a.318.318,0,0,1,.37.518l-57.15,40.763a.315.315,0,0,1-.184.059",
    fill: "#5da64c"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M64.607,215.585l1.451-1.612a.592.592,0,0,0,0-.791l-1.451-1.629a.592.592,0,0,0-.885,0l-1.452,1.629a.592.592,0,0,0,0,.791l1.451,1.612a.592.592,0,0,0,.881,0",
    fill: "#5da64c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M173.057,233.752a.316.316,0,0,1-.18-.056l-57.866-39.738a.318.318,0,1,1,.36-.524l57.866,39.738a.318.318,0,0,1-.18.58",
    fill: "#5da64c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M115.55,234.265a.318.318,0,0,1-.185-.577l57.149-40.763a.318.318,0,1,1,.369.518l-57.149,40.763a.315.315,0,0,1-.184.059",
    fill: "#5da64c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M144.565,215.585l1.451-1.612a.592.592,0,0,0,0-.791l-1.452-1.629a.592.592,0,0,0-.885,0l-1.451,1.629a.592.592,0,0,0,0,.791l1.451,1.612a.592.592,0,0,0,.881,0",
    fill: "#5da64c"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M261.482,233.752a.316.316,0,0,1-.18-.056l-57.866-39.738a.318.318,0,1,1,.36-.524l57.866,39.738a.318.318,0,0,1-.18.58",
    fill: "#5da64c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M203.975,234.265a.318.318,0,0,1-.185-.577l57.149-40.763a.318.318,0,0,1,.37.518l-57.15,40.763a.314.314,0,0,1-.184.059",
    fill: "#5da64c"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M232.99,215.585l1.451-1.612a.592.592,0,0,0,0-.791l-1.451-1.629a.592.592,0,0,0-.885,0l-1.452,1.629a.592.592,0,0,0,0,.791l1.451,1.612a.592.592,0,0,0,.881,0",
    fill: "#5da64c"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M36.03,285.059H12.635A5.531,5.531,0,0,1,7.1,279.528V221.09a5.531,5.531,0,0,1,5.531-5.531H36.03Z",
    fill: "#5da64c"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M44.033,285.059H36.1a4.681,4.681,0,0,1-4.681-4.681V220.243a4.684,4.684,0,0,1,4.685-4.684h7.932a4.685,4.685,0,0,1,4.685,4.684v60.131a4.685,4.685,0,0,1-4.685,4.685",
    fill: "#80d97e"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M41.2,292.9H39.461l-1.735-7.845H41.2Z",
    fill: "#8c4c3a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M42.931,292.9H41.2v-7.845h3.47Z",
    fill: "#a25c44"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M16.431,292.9H14.7l-1.735-7.845h3.47Z",
    fill: "#8c4c3a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M18.166,292.9H16.431v-7.845H19.9Z",
    fill: "#a25c44"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M84.365,292.752c2.785.955,6.562-2.7,8.435-8.163s1.135-10.666-1.651-11.621-6.562,2.7-8.435,8.162S81.58,291.8,84.365,292.752",
    fill: "#d06d6d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M100.832,229.533l-.311-.043-29.546-4.131A6.419,6.419,0,0,0,69.2,238.073l22.768,3.183-8.156,39.378a4.059,4.059,0,0,0,7.848,2.039l14.188-45.212a6.586,6.586,0,0,0,.223-.99,6.146,6.146,0,0,0-5.236-6.938",
    fill: "#fd7e2c"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M76.759,292.8c2.911.446,5.979-3.821,6.854-9.53s-.125-11.506-3.035-11.951-6.631,4.628-7.505,10.337.776,10.7,3.686,11.144",
    fill: "#e47575"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M109.364,188.338a3.041,3.041,0,0,0-4.191-.969L87.795,198.217,77.772,182.551a5.516,5.516,0,0,0-.367-.5,5.077,5.077,0,1,0-7.819,6.477L83.649,205.5l.224.27a3.6,3.6,0,0,0,4.832.635l19.831-13.972a3.05,3.05,0,0,0,.828-4.1",
    fill: "#d06d6d"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M76.16,232.1l-21.966,2.838-3.541-54.593,22.81-.134c2.243,5.446,2.359,9.329,2.406,15.221Z",
    fill: "#e47575"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M90.325,234.829l-.331-.1-30.96-9.17a6.419,6.419,0,0,0-3.646,12.309l25.464,7.542L74.4,281.528a4.06,4.06,0,0,0,7.891,1.865l12.13-41.031a6.061,6.061,0,0,0-4.093-7.533",
    fill: "#fd915c"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M49.443,196.513v5.635h22.4a5.628,5.628,0,0,0,5.628-5.628v-.007a5.734,5.734,0,0,0-.04-.689,5.636,5.636,0,0,0-5.588-4.939H55.071a5.628,5.628,0,0,0-5.094,3.236,5.536,5.536,0,0,0-.534,2.392",
    fill: "#d06d6d"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M50.653,193.917a7.68,7.68,0,0,0,1.6,4.074,5.132,5.132,0,0,0,3.987,2.046H73a4.684,4.684,0,0,0,2-.451,4.957,4.957,0,0,0,1.519-7.6,5.139,5.139,0,0,0-4.007-2.083H55.747a5.692,5.692,0,0,0-5.094,4.016",
    fill: "#e47575"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M69.931,202.148s-11.067,4.809-14.486,19.164H53.012l-.673-19.164Z",
    fill: "#d06d6d"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M108.171,186.467c-.153,2.73,3.482,5.153,8.119,5.413s8.52-1.742,8.673-4.471-3.652-2.117-8.289-2.377-8.35-1.294-8.5,1.435",
    fill: "#fd915c"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M106.857,192.943a3.041,3.041,0,0,1-1.684-5.574l3.213-2.133a3.041,3.041,0,0,1,3.363,5.067l-3.214,2.132a3.028,3.028,0,0,1-1.678.508",
    fill: "#fd915c"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M101.24,228.731a.328.328,0,0,1,.014.652,41.292,41.292,0,0,0-8.769,2.341C84.6,234.762,78.55,239.682,75.916,244.6a1.751,1.751,0,0,1-1.861.91L57.235,242.4A8.951,8.951,0,0,1,50.2,231.326l2.863-10.91H75.575A10.983,10.983,0,0,0,84.8,227.27Z",
    fill: "#e47575"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M59.844,242.4a8.95,8.95,0,0,1-7.032-11.072l2.863-10.911H53.066L50.2,231.327A8.949,8.949,0,0,0,57.235,242.4l16.82,3.106a1.723,1.723,0,0,0,1.249-.251Z",
    fill: "#d06d6d"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M52.252,180.471a5.073,5.073,0,0,0-6.165,3.671l-6.078,23.974-5.973,1.054a3.05,3.05,0,0,0,.592,6.052l8.752-.176a3.307,3.307,0,0,0,3.032-2.17l.159-.436,9.2-25.317c.056-.156.108-.323.149-.487a5.074,5.074,0,0,0-3.671-6.165",
    fill: "#e47575"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M35.4,214.794a4.838,4.838,0,1,1-4.838-4.838,4.838,4.838,0,0,1,4.838,4.838",
    fill: "#fd915c"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M29.947,215.406a2.7,2.7,0,0,1-.264-5.392l6.3-.627a2.7,2.7,0,1,1,.535,5.378l-6.3.627c-.091.009-.182.014-.271.014",
    fill: "#fd915c"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M77.671,194.97l-2.26-7.864-1.33,4.8Z",
    fill: "#e47575"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M47.113,155.005V174.7H81.064a18.494,18.494,0,0,1-2.367-9.053V155.005a14.248,14.248,0,0,0-14.249-14.249H61.362a14.446,14.446,0,0,0-2.305.186l-.167.028A14.256,14.256,0,0,0,47.5,151.705a13.84,13.84,0,0,0-.39,3.3",
    fill: "#805a3f"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M78.226,155.006V174.7H44.273a21.579,21.579,0,0,0,2.367-9.827v-9.865a13.753,13.753,0,0,1,.389-3.3,14.248,14.248,0,0,1,11.39-10.735c.053-.013.11-.022.163-.031a14.75,14.75,0,0,1,2.305-.186h3.087a14.24,14.24,0,0,1,14.252,14.252",
    fill: "#805a3f"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M73.49,155.006v13.3A6.39,6.39,0,0,1,67.1,174.7H49.078V164.622a13.759,13.759,0,0,1,.39-3.3,14.248,14.248,0,0,1,11.385-10.735c.058-.009.115-.022.168-.031a14.689,14.689,0,0,1,2.3-.185h3.088a14.273,14.273,0,0,1,3.953.554,4.27,4.27,0,0,1,3.124,4.051Z",
    fill: "#70452a"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M63.6,188.292h0c4.71-.047,6.543-4.924,4.592-9.211l-4.837-10.626-6.219.257-1.347,12.362c-.423,3.879,3.909,7.257,7.811,7.218",
    fill: "#fd7e2c"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M49.229,160.036c.267,6.2,3.8,11.3,8.567,13.146a10.438,10.438,0,0,0,1.748.52,10.872,10.872,0,0,0,2.844.213,11.06,11.06,0,0,0,4.359-1.2c4.661-2.351,7.8-7.9,7.532-14.174-.335-7.82-6.314-13.616-6.348-13.6-.171.075-4.7,3.288-7.72,5.057-4,2.343-11.263,3.555-10.982,10.032",
    fill: "#fd915c"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M67.928,165.893a3.863,3.863,0,0,1-7.719,0l.5.013c1.1.027,2.221.04,3.362.04s2.26-.013,3.357-.04l.5-.013",
    fill: "#fd6160"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M67.429,165.906a5.787,5.787,0,0,1-6.719,0c1.1.027,2.221.04,3.362.04s2.26-.013,3.357-.04",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M68.919,159.92c0,.944.765,1.176,1.709,1.176s1.709-.232,1.709-1.176a1.709,1.709,0,1,0-3.418,0",
    fill: "#805a3f"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M57.815,159.92c0,.944.765,1.176,1.709,1.176s1.709-.232,1.709-1.176a1.709,1.709,0,0,0-3.418,0",
    fill: "#805a3f"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M49.656,159.3c0,1.6-.521,2.9-1.165,2.9s-1.164-1.3-1.164-2.9.521-2.9,1.164-2.9,1.165,1.3,1.165,2.9",
    fill: "#fd7e2c"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M60.622,155.772a10.9,10.9,0,0,1-1.6.407l-1.618.329.077-.037c-.586.457-1.182.9-1.78,1.343a.111.111,0,0,1-.14-.171c.554-.5,1.11-.99,1.677-1.471a.169.169,0,0,1,.066-.035l.011,0,1.593-.435a10.784,10.784,0,0,1,1.612-.357.222.222,0,0,1,.1.43",
    fill: "#805a3f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M69.787,155.824a10.771,10.771,0,0,1,1.611.357l1.594.435.012,0a.171.171,0,0,1,.065.035c.368.319.726.652,1.082.987a.111.111,0,0,1-.14.171c-.4-.28-.8-.563-1.186-.859l.077.038-1.618-.33a10.676,10.676,0,0,1-1.6-.407.222.222,0,0,1,.1-.43",
    fill: "#805a3f"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M51.731,158.814a23.427,23.427,0,0,1-.026-4.332,6.5,6.5,0,0,0-2.477,5.554c.268,6.2,3.8,11.3,8.567,13.146a10.536,10.536,0,0,0,1.748.521c.129.026.26.046.39.068-4.349-2.979-7.558-8.451-8.2-14.957",
    fill: "#fd7e2c"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M48.772,174.7h0a2.37,2.37,0,0,0,2.37-2.37V148.574h-2.37Z",
    fill: "#805a3f"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M123.707,262.2c-.559,3.178-2.827,5.436-5.065,5.042s-3.6-3.289-3.042-6.467,2.827-5.436,5.065-5.043,3.6,3.29,3.042,6.468",
    fill: "#fdde2e"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M150.426,258.37c1.084,3.04.228,6.123-1.913,6.886s-4.756-1.081-5.84-4.121-.227-6.122,1.914-6.886,4.755,1.081,5.839,4.121",
    fill: "#fdde2e"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M126.89,213.7l8.706,7.757-4.536.558,7.512-9.228a2.034,2.034,0,0,1,3.35,2.282l-5.836,10.369a2.829,2.829,0,0,1-3.854,1.078,2.863,2.863,0,0,1-.484-.342l-.2-.177-8.705-7.757a3.04,3.04,0,1,1,4.045-4.54",
    fill: "#fd915c"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M145.684,257.781a3.042,3.042,0,0,1-2.875-2.052l-4.131-12.016h-22.3a3.041,3.041,0,1,1,0-6.082h24.466a3.041,3.041,0,0,1,2.875,2.052l4.838,14.068a3.043,3.043,0,0,1-2.876,4.03",
    fill: "#fd7e2c"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M123.111,258.609a3.041,3.041,0,0,1-2.781-4.266l4.716-10.718H113.662a3.04,3.04,0,0,1,0-6.081h16.044a3.041,3.041,0,0,1,2.783,4.265L125.9,256.792a3.042,3.042,0,0,1-2.785,1.817",
    fill: "#fd915c"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M138.491,237.246c-.515,2.955-2.93,5.587-6.552,7.487a23.826,23.826,0,0,1-3.718,1.544A32.746,32.746,0,0,1,118.16,247.8a35.046,35.046,0,0,1-4.678-.311,30.482,30.482,0,0,1-3.813-.75,22.794,22.794,0,0,1-7.315-3.235l.839-.68a17.62,17.62,0,0,0,6.552-14.459l-.54-12.87a4.583,4.583,0,0,1,4.576-4.315h8.834a4.574,4.574,0,0,1,4.455,3.521l1.723,13.969a9.768,9.768,0,0,0,9.7,8.58",
    fill: "#fde371"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M113.482,247.484a30.482,30.482,0,0,1-3.813-.75,17.646,17.646,0,0,0,4.118-10.111l1.023-12.8,1.227,12.869a17.513,17.513,0,0,1-2.555,10.792",
    fill: "#f8d769"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M131.938,244.732a23.788,23.788,0,0,1-3.718,1.544,9.764,9.764,0,0,1-4.614-8.338l-.025-14.185,2.478,13.715a9.769,9.769,0,0,0,5.879,7.264",
    fill: "#f8d769"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M132.437,200.675c0,9.936-5.953,8.48-13.631,8.48s-14.187,1.456-14.187-8.48a22.07,22.07,0,0,1,1.976-9.264c2.437-5.226,6.872-8.726,11.936-8.726s9.493,3.5,11.93,8.726a22.07,22.07,0,0,1,1.976,9.264",
    fill: "#805a3f"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M118.531,208.169h0c-6.851,0-12.457-4.305-12.457-11.157,0,0,5.606-12.457,12.457-12.457s12.457,12.457,12.457,12.457c0,6.852-5.605,11.157-12.457,11.157",
    fill: "#fd914c"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M118.531,214.607h0a3.5,3.5,0,0,1-3.5-3.5v-7.253h7v7.253a3.5,3.5,0,0,1-3.5,3.5",
    fill: "#fd914c"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M107.95,197.61c0,1.185-.722,2.145-1.612,2.145s-1.612-.96-1.612-2.145.721-2.145,1.612-2.145,1.612.96,1.612,2.145",
    fill: "#fd914c"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M130.462,191.71a107.246,107.246,0,0,1-23.867,0c2.438-5.405,6.872-9.026,11.937-9.026s9.492,3.621,11.93,9.026",
    fill: "#805a3f"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M121.71,187.956l-.7,5.747h1.392Z",
    fill: "#fd914c"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M124.869,202.256a3.732,3.732,0,0,1-.277,1.426,3.862,3.862,0,0,1-3.6,2.452,3.762,3.762,0,0,1-1.649-.371,3.867,3.867,0,0,1-2.23-3.507v-.068c1.2.048,2.446.068,3.71.068,1.385,0,2.736-.027,4.04-.074,0,.02.007.047.007.074",
    fill: "#fd6160"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M124.335,203.771a3.047,3.047,0,0,1-2.841,1.935,2.965,2.965,0,0,1-1.3-.293,3.048,3.048,0,0,1,2.841-1.935,2.962,2.962,0,0,1,1.3.293",
    fill: "#fdb4b4"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M116.381,197.2a1.35,1.35,0,1,1-1.35-1.35,1.35,1.35,0,0,1,1.35,1.35",
    fill: "#805a3f"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M128.3,197.2a1.35,1.35,0,1,1-1.35-1.35,1.35,1.35,0,0,1,1.35,1.35",
    fill: "#805a3f"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M114.481,217.685c-1.554,1.641-3.1,3.227-4.691,4.816s-3.189,3.146-4.964,4.691c-.45.388-.9.772-1.442,1.174a11.423,11.423,0,0,1-.95.643l-.371.2-.094.047-.153.065c-.109.044-.22.084-.332.121l-.168.051a.576.576,0,0,1-.073.018l-.1.021-.2.041-1.682.342c-.6.114-1.235.206-1.834.267-2.379.217-4.533.247-6.761.335a2.029,2.029,0,0,1-.373-4.035l.032,0c2.163-.306,4.412-.58,6.4-.974.49-.1.938-.215,1.412-.357l1.522-.476.2-.063.1-.032c.006,0,.058-.015.025-.01l-.072.014a.93.93,0,0,0-.138.046l-.057.026,0,0-.011,0,.379-.338c.318-.293.674-.658,1.023-1.029,1.41-1.506,2.811-3.185,4.183-4.859s2.737-3.4,4.051-5.111l.007-.008a3.382,3.382,0,1,1,5.137,4.389",
    fill: "#fd915c"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M146.45,210.705c.209,1.727-1.356,3.337-3.5,3.6s-4.045-.93-4.254-2.657,1.356-3.337,3.5-3.6,4.045.931,4.254,2.658",
    fill: "#fd915c"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M92.424,228.762c-.119,1.736-1.959,3.023-4.11,2.875s-3.8-1.674-3.68-3.409,1.96-3.023,4.111-2.876,3.8,1.674,3.679,3.41",
    fill: "#fd915c"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M121.225,263.032a3.18,3.18,0,0,1-2.907-4.458l1.886-4.286a3.178,3.178,0,1,1,5.817,2.56l-1.886,4.285a3.18,3.18,0,0,1-2.91,1.9",
    fill: "#f7f5c1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M146.8,261.164a3.18,3.18,0,0,1-3-2.145l-1.559-4.535a3.178,3.178,0,1,1,6.01-2.067l1.56,4.535a3.179,3.179,0,0,1-3.006,4.212",
    fill: "#eeeab9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M254.315,228.552c-7.2.035-19.4.89-31.281,5.362l15.8,13.841,7.087-.208a10.785,10.785,0,0,0,9.964-14.042Z",
    fill: "#01b8c3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M254.315,228.552l-.054-.17-12.409-9.431-17.552,5.2-5.8,5.785,4.535,3.974c11.886-4.472,24.077-5.327,31.281-5.362",
    fill: "#039dae"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M231.2,245.531l-32.861,3.993,7.894-7.536-10.8,45.7a6.094,6.094,0,0,1-11.992-2.025l4.8-46.714a8.389,8.389,0,0,1,7.326-7.469l.568-.067L229,227.422a9.121,9.121,0,0,1,2.2,18.109",
    fill: "#039dae"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M216.4,189.623l-17.007-6.374,2.585.229-30.8,1.184a4.066,4.066,0,0,1-.932-8.054l30.259-5.882a4.109,4.109,0,0,1,1.691.023l.894.206,17.7,4.061a7.644,7.644,0,1,1-3.418,14.9,8.624,8.624,0,0,1-.973-.293",
    fill: "#fd7e2c"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M234.612,195.823a8.242,8.242,0,0,1-2.382-.352l-13.44-4.04a8.262,8.262,0,0,1,4.758-15.825l13.44,4.041a8.263,8.263,0,0,1-2.376,16.176",
    fill: "#eae392"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M263.585,181.439a88.226,88.226,0,0,0-7.773,29.375l-1.55,17.566L239.631,224.9a22.906,22.906,0,0,0-11.452.216,23.63,23.63,0,0,0-3.013,1.068l-5.046,2.192.541-1.328a88.248,88.248,0,0,0,6.272-29.667,52.164,52.164,0,0,1,1.449-8.5.265.265,0,0,0,.007-.051c.279-1.2.578-2.4.87-3.553a14.676,14.676,0,0,1,9.445-10.245l5.4-1.868,16.206,4.4Z",
    fill: "#faf7ac"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M228.382,188.887c-.146,1.252-2.892,25.206-.2,36.232a23.521,23.521,0,0,0-3.013,1.068l-5.046,2.193.54-1.329a88.244,88.244,0,0,0,6.273-29.667,52.181,52.181,0,0,1,1.449-8.5",
    fill: "#eae392"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M272.6,187.765l13,15.118-4.49-2.65,19.684,8.419a3.97,3.97,0,0,1-1.592,7.619l-21.408-.165a4.885,4.885,0,0,1-3.663-1.689l-.827-.962-13-15.118a8.108,8.108,0,1,1,12.3-10.572",
    fill: "#fd915c"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M266.455,201.313a8.241,8.241,0,0,1-6.268-2.876L254.05,191.3a8.262,8.262,0,1,1,12.529-10.772l6.137,7.138a8.261,8.261,0,0,1-6.261,13.648",
    fill: "#faf7ac"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M313.945,217.168a9.2,9.2,0,1,1-9.2-9.2,9.2,9.2,0,0,1,9.2,9.2",
    fill: "#fd915c"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M311.1,213.565c0,2.382-2.716,4.313-6.066,4.313s-6.066-1.931-6.066-4.313,2.716-4.313,6.066-4.313,6.066,1.931,6.066,4.313",
    fill: "#fd987c"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M242.81,183.4h0a7.481,7.481,0,0,1-7.481-7.481V157.535h14.962v18.381a7.481,7.481,0,0,1-7.481,7.481",
    fill: "#fd7e2c"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M231.016,153.234c0,9.458,6.535,17.125,14.6,17.125s14.6-7.667,14.6-17.125c0-4.339-.413-9.434-2.68-12.451-.885-1.178-3.638-.175-4.766-1.031-2.282-1.732-4.231-3.643-7.15-3.643-8.061,0-14.6,7.667-14.6,17.125",
    fill: "#a44923"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M240.964,172.254c.364.053.733.086,1.1.107a13.6,13.6,0,0,0,3.248-.214,13.905,13.905,0,0,0,11.306-12.89l.412-8a12.806,12.806,0,0,0-6.779-11.949,12.615,12.615,0,0,0-5.313-1.482l-11.253-.583a3.949,3.949,0,0,0-1.231.128,4.155,4.155,0,0,0-3.151,3.816l-.846,16.062a14.423,14.423,0,0,0,12.505,15",
    fill: "#fd7e2c"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M240.964,172.254c.23-.027.455-.064.68-.107a13.906,13.906,0,0,0,11.306-12.89l.417-8a12.826,12.826,0,0,0-6.779-11.949,12.658,12.658,0,0,0-5.319-1.482l-8.813-.455a4.155,4.155,0,0,0-3.151,3.816l-.846,16.062a14.423,14.423,0,0,0,12.505,15",
    fill: "#fd915c"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M254.676,153.085c-.15,2.858,1.006,5.241,2.581,5.324s2.973-2.168,3.122-5.025-1.006-5.242-2.58-5.324-2.973,2.167-3.123,5.025",
    fill: "#fd7e2c"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M234.441,163.666v.273a3.921,3.921,0,0,0,3.922,3.922h.942a3.921,3.921,0,0,0,3.922-3.922v-.273Z",
    fill: "#fd6160"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M234.784,163.666a4.174,4.174,0,0,0,2.863,1.129h2.381a4.17,4.17,0,0,0,2.857-1.129Z",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M245.133,157.541c-.215.74.228,1,.968,1.214s1.5.3,1.713-.437a1.4,1.4,0,0,0-2.681-.777",
    fill: "#5b2411"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    "data-name": "Path 652",
    d: "M231.018,158.016c.039.77.542.87,1.312.83s1.515-.2,1.475-.973a1.4,1.4,0,1,0-2.787.143",
    fill: "#5b2411"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_653",
    "data-name": "Path 653",
    d: "M225.945,139.372h0a5.974,5.974,0,0,1,5.837-6.073l.273-.006a6.278,6.278,0,0,0-3.44,5.706l.012.64a6.28,6.28,0,0,0,3.665,5.564l-.273.006a5.974,5.974,0,0,1-6.074-5.837",
    fill: "#a44923"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M234.049,145.448l14.254-.283a5.555,5.555,0,0,0-.221-11.108l-14.254.283a5.555,5.555,0,1,0,.221,11.108",
    fill: "#a44923"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M249.175,144.107c.068,2.729,5.785,15.272,6.217,11.78.335-2.71,3.743-9.3,3.675-12.026a4.948,4.948,0,0,0-9.892.246",
    fill: "#a44923"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M238.423,137c.018.921,2.831,1.613,6.283,1.544s6.235-.871,6.216-1.792-2.831-1.613-6.282-1.544-6.235.871-6.217,1.792",
    fill: "#ca5c2e"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M243.273,136.827c.01.5,1.527.87,3.389.833s3.364-.47,3.354-.967-1.527-.87-3.389-.833-3.364.47-3.354.967",
    fill: "#d86339"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M243.679,152.968c.637.016,1.271.071,1.9.144s1.264.138,1.893.241l.032.005a.228.228,0,0,1,.132.073l1.1,1.27a.161.161,0,0,1-.229.225l-1.249-1.12.164.079c-.637-.025-1.269-.094-1.9-.144s-1.265-.128-1.893-.241a.268.268,0,0,1,.054-.532",
    fill: "#a44923"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M234.923,152.711c-.628.112-1.259.186-1.893.241s-1.266.118-1.9.144l.164-.079-1.249,1.119a.161.161,0,0,1-.229-.225l1.1-1.269a.215.215,0,0,1,.13-.073l.034-.006c.628-.1,1.261-.162,1.893-.24s1.265-.128,1.9-.144a.268.268,0,0,1,.054.532",
    fill: "#a44923"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M246.461,247.536l-14.091.415,8.725-7.6-10.8,45.7a6.094,6.094,0,0,1-11.992-2.025l4.8-46.714a8.452,8.452,0,0,1,8.155-7.583l.57-.015,14.092-.416a9.121,9.121,0,1,1,.537,18.235",
    fill: "#01b8c3"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M171.665,293.039h26.1a1.394,1.394,0,0,0,1.394-1.395v-.607H170.27v.607a1.4,1.4,0,0,0,1.395,1.395",
    fill: "#315050"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M235.329,176.2l-12.807-.865,7.576,5.675Z",
    fill: "#eae392"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M170.271,291.206h28.891v-1.775a3.619,3.619,0,0,0-3.077-3.386L181.827,283.1c-5.9-1.219-11.556,2.668-11.556,7.937Z",
    fill: "#536868"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M206.219,293.039h26.1a1.394,1.394,0,0,0,1.395-1.395v-.607H204.824v.607a1.4,1.4,0,0,0,1.395,1.395",
    fill: "#315050"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M204.825,291.206h28.891v-1.775a3.62,3.62,0,0,0-3.077-3.386L216.381,283.1c-5.9-1.219-11.556,2.668-11.556,7.937Z",
    fill: "#536868"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M165.869,263.1c.549,4.537-1.489,8.516-4.554,8.887s-5.994-3.006-6.543-7.543,1.489-8.516,4.553-8.887,5.994,3.006,6.544,7.543",
    fill: "#016179"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M159.284,231.08l12.238-4.531,16.468,4.043-18.094,2.35Z",
    fill: "#0076aa"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M170.63,240.964l-14.151.422,4.319-5.36,3.553,25.828a4.73,4.73,0,0,1-9.371,1.289l-3.553-25.827a4.725,4.725,0,0,1,4.036-5.325l.028,0,.255-.033,14.046-1.769a5.411,5.411,0,1,1,1.353,10.738c-.17.021-.347.035-.515.04",
    fill: "#fd7e2c"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M175.161,234.892a5.575,5.575,0,0,0-6.07-5.1l-9.807,1.286a33.649,33.649,0,0,1,3.232,10.565l7.466-.2a5.009,5.009,0,0,0,.515-.041,5.709,5.709,0,0,0,4.664-6.507",
    fill: "#0076aa"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M181.581,242.314a6.413,6.413,0,0,0,1.931-.153c3.674-.881,5.968-4.876,5.123-8.923s-4.509-6.613-8.184-5.731l-11.278,2.7a39.163,39.163,0,0,0,4.658,11.53l-.009-.027Z",
    fill: "#0484c1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_671",
    "data-name": "Path 671",
    d: "M172.115,210.441,161.061,224.03l-.293.36A3.2,3.2,0,0,1,157,225.3l-8.717-3.813a3.042,3.042,0,0,1,2.238-5.654l8.966,3.185-4.058,1.272,8.241-15.458a5.091,5.091,0,0,1,8.985,4.789,5.4,5.4,0,0,1-.543.818",
    fill: "#fd7e2c"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_672",
    "data-name": "Path 672",
    d: "M165.587,217.246a5.407,5.407,0,0,1-4.86-7.764l2.223-4.586a5.405,5.405,0,1,1,9.728,4.715l-2.223,4.586a5.405,5.405,0,0,1-4.868,3.049",
    fill: "#ffafb0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_673",
    "data-name": "Path 673",
    d: "M188.464,228.262l-.473,2.331a47.6,47.6,0,0,0-25.155-.426l-3.554.913,1.412-2.291a44.874,44.874,0,0,0,4.825-21.087l-.048-2.568a3.143,3.143,0,0,1,2.946-3.2l1.122-.067,1.351-.081,8.236-.507,1.4-.088,2.1-.128a5.216,5.216,0,0,1,5.425,4.1l.264,1.209a52.968,52.968,0,0,1,.155,21.885",
    fill: "#fdc8c8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M188.311,206.377l-.264-1.212a5.223,5.223,0,0,0-3.389-3.817v10.258a53.054,53.054,0,0,1-.711,16.654l-.263,1.291c1.446.28,2.884.624,4.3,1.04l.475-2.331a53.061,53.061,0,0,0-.153-21.883",
    fill: "#f7b2b0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M189.036,208.527l-5.936,14.8-.157.392a3.01,3.01,0,0,1-2.866,1.884l-13.514-.359a3.041,3.041,0,0,1,.161-6.079l13.514.359-3.024,2.275,2.012-15.816a5.109,5.109,0,0,1,10.136,1.29,5.326,5.326,0,0,1-.326,1.257",
    fill: "#fd915c"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_676",
    "data-name": "Path 676",
    d: "M182.106,219.335a5.411,5.411,0,0,1-5.236-6.765l1.909-7.35a5.405,5.405,0,1,1,10.463,2.717l-1.908,7.35a5.407,5.407,0,0,1-5.228,4.048",
    fill: "#fdc8c8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_677",
    "data-name": "Path 677",
    d: "M163.355,225.091l-12.706-1.737a1.185,1.185,0,0,1-1.013-1.334l.976-7.138a1.183,1.183,0,0,1,1.334-1.013l12.706,1.737a1.185,1.185,0,0,1,1.013,1.334l-.976,7.138a1.184,1.184,0,0,1-1.334,1.013",
    fill: "#ececec"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M163.4,225.877,150.7,224.14a1.185,1.185,0,0,1-1.013-1.334l.976-7.138a1.184,1.184,0,0,1,1.334-1.013l12.706,1.737a1.185,1.185,0,0,1,1.013,1.334l-.976,7.138a1.185,1.185,0,0,1-1.334,1.013",
    fill: "#dedede"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M152.681,218.495a3.623,3.623,0,1,1-3.839-3.394,3.623,3.623,0,0,1,3.839,3.394",
    fill: "#fd914c"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M167.834,221.57a3.623,3.623,0,1,1-3.839-3.393,3.623,3.623,0,0,1,3.839,3.393",
    fill: "#fd914c"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M175.616,235.416c.653,3.47-1.211,6.733-4.163,7.288s-5.874-1.806-6.527-5.276,1.21-6.733,4.162-7.288,5.875,1.806,6.528,5.276",
    fill: "#026883"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M177.448,215.971a.291.291,0,0,1-.083-.011.337.337,0,0,1-.245-.41l1.545-6.087a.335.335,0,0,1,.41-.244.339.339,0,0,1,.245.411l-1.545,6.086a.338.338,0,0,1-.327.255",
    fill: "#f7b2b0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M171.008,196.362v5.673c0,2.917,2.262,5.124,4.722,4.6a4.278,4.278,0,0,0,3.112-3.209l1.694-9.317Z",
    fill: "#fd914c"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M179.126,201.283l-.412,1.946a4,4,0,0,1-7.824-1.2v-.243l-1.351.081v.162a5.345,5.345,0,0,0,5.344,5.358,5.1,5.1,0,0,0,.959-.088,5.357,5.357,0,0,0,4.176-3.73l.507-2.378Z",
    fill: "#fde4e4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M175.57,198.875h0c7.307-1.375,12.421-7.092,11.046-14.4,0,0-8.479-12.16-15.786-10.785s-10.785,15.786-10.785,15.786c1.375,7.307,8.218,10.773,15.525,9.4",
    fill: "#fd914c"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M184.829,185.651c.238,1.264,1.2,2.143,2.15,1.964A2.1,2.1,0,0,0,188.268,185c-.238-1.264-1.2-2.143-2.15-1.964a2.1,2.1,0,0,0-1.289,2.611",
    fill: "#fd914c"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M159.35,190.346c.238,1.263,1.2,2.143,2.15,1.964a2.1,2.1,0,0,0,1.289-2.611c-.238-1.264-1.2-2.143-2.15-1.964a2.1,2.1,0,0,0-1.289,2.611",
    fill: "#fd914c"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M173.917,196.918a4.331,4.331,0,0,1-5.061-3.453c-.006-.027-.006-.06-.013-.087.155-.028.317-.048.479-.075,1.291-.2,2.629-.425,3.973-.675,1.3-.25,2.581-.507,3.811-.784.088-.014.169-.034.25-.054a.232.232,0,0,1,.014.074,4.321,4.321,0,0,1-3.453,5.054",
    fill: "#fd6160"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M177.106,191.844a6.893,6.893,0,0,1-7.784,1.459c1.291-.195,2.629-.425,3.973-.675,1.3-.25,2.581-.507,3.811-.784",
    fill: "#fff"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M177.072,187.564a1.465,1.465,0,1,0,1.169-1.71,1.465,1.465,0,0,0-1.169,1.71",
    fill: "#5b2411"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M164.362,189.956a1.465,1.465,0,1,0,1.169-1.71,1.465,1.465,0,0,0-1.169,1.71",
    fill: "#5b2411"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M161.479,179.9s-4.3,4.974.194,9.236c0,0-.886-5.471,2.22-7.112,0,0,.2-2.672-2.414-2.124",
    fill: "#a44923"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M181.947,176.668s5.868,3.227,3.276,8.741c0,0-1.222-5.436-4.728-5.936,0,0-1.188-2.442,1.452-2.805",
    fill: "#a44923"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_694",
    "data-name": "Path 694",
    d: "M159.456,180.419c.229,2.622,2.809,3.168,6.9.2,4.019-2.919,9.581.3,9.352-2.318s-3.577-5.838-8.53-5.313-7.95,4.812-7.721,7.434",
    fill: "#a44923"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_695",
    "data-name": "Path 695",
    d: "M177.268,170.106c4.19-.676,4.524,2.934-1,1.966s-6.829-.012-6.829-.012l.007.021a3.058,3.058,0,0,0-.412.187c-1.885,1.2-1.888,4.185-.008,6.678a7.4,7.4,0,0,0,3.406,2.557,12.08,12.08,0,0,0,9.563-.7c4.992-2.6,5.64-6.817,3.181-10.436-2.55-3.756-7.9-.264-7.9-.264",
    fill: "#a44923"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_696",
    "data-name": "Path 696",
    d: "M173.469,264.149c-.313,4.559-3.063,8.084-6.142,7.873s-5.323-4.078-5.01-8.638,3.063-8.084,6.142-7.873,5.323,4.078,5.01,8.638",
    fill: "#026883"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_697",
    "data-name": "Path 697",
    d: "M167.5,266.93c-.129,0-.258-.006-.389-.017a4.392,4.392,0,0,1-3.991-4.759l2.392-27.239a4.392,4.392,0,0,1,8.75.768l-2.392,27.239a4.392,4.392,0,0,1-4.37,4.008",
    fill: "#fd915c"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_698",
    "data-name": "Path 698",
    d: "M380.417,289.138H272.448a2.687,2.687,0,0,1-2.688-2.688V228.139a2.687,2.687,0,0,1,2.688-2.688H380.417a2.687,2.687,0,0,1,2.688,2.688V286.45a2.687,2.687,0,0,1-2.688,2.688",
    fill: "#3e472d"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_699",
    "data-name": "Path 699",
    d: "M382.577,289.138H274.608a2.687,2.687,0,0,1-2.688-2.688V228.139a2.687,2.687,0,0,1,2.688-2.688H382.577a2.687,2.687,0,0,1,2.688,2.688V286.45a2.687,2.687,0,0,1-2.688,2.688",
    fill: "#293020"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M342.584,283.37H308.842a.965.965,0,0,1-.965-.965V258.259a.965.965,0,0,1,.965-.965h33.742a.965.965,0,0,1,.965.965V282.4a.965.965,0,0,1-.965.965",
    fill: "#383d2d"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M269.04,284.09a.72.72,0,0,1-.72-.72V231.218a.72.72,0,1,1,1.44,0V283.37a.72.72,0,0,1-.72.72",
    fill: "#66f9ff"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M344.743,283.37H311a.965.965,0,0,1-.965-.965V258.259a.965.965,0,0,1,.965-.965h33.742a.965.965,0,0,1,.965.965V282.4a.965.965,0,0,1-.965.965",
    fill: "#2f3525"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_703",
    "data-name": "Path 703",
    d: "M337.622,264.169h-19.5a.54.54,0,1,1,0-1.08h19.5a.54.54,0,0,1,0,1.08",
    fill: "#1e2317"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_704",
    "data-name": "Path 704",
    d: "M337.622,270.872h-19.5a.54.54,0,1,1,0-1.08h19.5a.54.54,0,0,1,0,1.08",
    fill: "#1e2317"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_705",
    "data-name": "Path 705",
    d: "M337.622,277.575h-19.5a.54.54,0,1,1,0-1.08h19.5a.54.54,0,0,1,0,1.08",
    fill: "#1e2317"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    width: 47.257,
    height: 10.602,
    transform: "translate(303.164 289.137)",
    fill: "#293020"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2031",
    "data-name": "Rectangle 2031",
    width: 47.257,
    height: 10.602,
    transform: "translate(304.964 289.137)",
    fill: "#1e2317"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_706",
    "data-name": "Path 706",
    d: "M365.369,305.56H288.216a5.82,5.82,0,0,1,5.821-5.82h65.512a5.82,5.82,0,0,1,5.82,5.82",
    fill: "#3e472d"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M367.169,305.56H290.016a5.82,5.82,0,0,1,5.821-5.82h65.512a5.82,5.82,0,0,1,5.82,5.82",
    fill: "#2f3525"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2032",
    "data-name": "Rectangle 2032",
    width: 7.056,
    height: 16.333,
    transform: "translate(249.591 309.332)",
    fill: "#cc8001"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2033",
    "data-name": "Rectangle 2033",
    width: 7.056,
    height: 16.333,
    transform: "translate(256.54 309.332)",
    fill: "#b26901"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2034",
    "data-name": "Rectangle 2034",
    width: 7.056,
    height: 16.333,
    transform: "translate(270.926 309.332)",
    fill: "#cc8001"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 7.056,
    height: 16.333,
    transform: "translate(277.875 309.332)",
    fill: "#b26901"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2036",
    "data-name": "Rectangle 2036",
    width: 7.056,
    height: 16.333,
    transform: "translate(343.572 309.332)",
    fill: "#cc8001"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2037",
    "data-name": "Rectangle 2037",
    width: 7.056,
    height: 16.333,
    transform: "translate(350.52 309.332)",
    fill: "#b26901"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2038",
    "data-name": "Rectangle 2038",
    width: 7.056,
    height: 16.333,
    transform: "translate(364.907 309.332)",
    fill: "#cc8001"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2039",
    "data-name": "Rectangle 2039",
    width: 7.056,
    height: 16.333,
    transform: "translate(371.855 309.332)",
    fill: "#b26901"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2040",
    "data-name": "Rectangle 2040",
    width: 7.056,
    height: 30.964,
    transform: "translate(249.591 309.331)",
    fill: "#cc8001"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2041",
    "data-name": "Rectangle 2041",
    width: 7.056,
    height: 30.964,
    transform: "translate(256.54 309.331)",
    fill: "#b26901"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2042",
    "data-name": "Rectangle 2042",
    width: 7.056,
    height: 30.964,
    transform: "translate(343.572 309.331)",
    fill: "#cc8001"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2043",
    "data-name": "Rectangle 2043",
    width: 7.056,
    height: 30.964,
    transform: "translate(350.52 309.331)",
    fill: "#b26901"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2044",
    "data-name": "Rectangle 2044",
    width: 7.056,
    height: 30.964,
    transform: "translate(364.907 309.331)",
    fill: "#cc8001"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2045",
    "data-name": "Rectangle 2045",
    width: 7.056,
    height: 30.964,
    transform: "translate(371.855 309.331)",
    fill: "#b26901"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2046",
    "data-name": "Rectangle 2046",
    width: 28.283,
    height: 3.772,
    transform: "translate(249.592 305.559)",
    fill: "#cc8001"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2047",
    "data-name": "Rectangle 2047",
    width: 101.037,
    height: 3.772,
    transform: "translate(277.874 305.559)",
    fill: "#b26901"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2048",
    "data-name": "Rectangle 2048",
    width: 28.283,
    height: 3.772,
    transform: "translate(249.592 325.665)",
    fill: "#cc8001"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2049",
    "data-name": "Rectangle 2049",
    width: 100.929,
    height: 3.772,
    transform: "translate(277.982 325.665)",
    fill: "#b26901"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M334.816,325.665h-64.9a.5.5,0,0,1-.5-.5v-8.385a.5.5,0,0,1,.5-.5h64.9a.5.5,0,0,1,.5.5v8.385a.5.5,0,0,1-.5.5",
    fill: "#3e472d"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M358.642,325.665h-64.9a.5.5,0,0,1-.5-.5v-8.385a.5.5,0,0,1,.5-.5h64.9a.5.5,0,0,1,.5.5v8.385a.5.5,0,0,1-.5.5",
    fill: "#293020"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M310.106,323.477H308.08a.358.358,0,0,1-.358-.358v-3.391a.359.359,0,0,1,.358-.359h2.026a.359.359,0,0,1,.358.359v3.391a.358.358,0,0,1-.358.358",
    fill: "#1e2317"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M317.807,323.477h-2.026a.358.358,0,0,1-.358-.358v-3.391a.359.359,0,0,1,.358-.359h2.026a.359.359,0,0,1,.358.359v3.391a.358.358,0,0,1-.358.358",
    fill: "#1e2317"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M325.508,323.477h-2.026a.357.357,0,0,1-.358-.358v-3.391a.358.358,0,0,1,.358-.359h2.026a.358.358,0,0,1,.357.359v3.391a.357.357,0,0,1-.357.358",
    fill: "#1e2317"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M333.208,323.477h-2.026a.358.358,0,0,1-.358-.358v-3.391a.359.359,0,0,1,.358-.359h2.026a.359.359,0,0,1,.358.359v3.391a.358.358,0,0,1-.358.358",
    fill: "#1e2317"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M340.154,320.973h-1.448a.181.181,0,0,1-.181-.182v-1.24a.182.182,0,0,1,.181-.182h1.448a.183.183,0,0,1,.182.182v1.24a.182.182,0,0,1-.182.182",
    fill: "#1e2317"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M340.154,323.477h-1.448a.181.181,0,0,1-.181-.182v-1.24a.182.182,0,0,1,.181-.182h1.448a.183.183,0,0,1,.182.182v1.24a.182.182,0,0,1-.182.182",
    fill: "#1e2317"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M346.277,320.973H344.83a.181.181,0,0,1-.182-.182v-1.24a.182.182,0,0,1,.182-.182h1.447a.183.183,0,0,1,.182.182v1.24a.182.182,0,0,1-.182.182",
    fill: "#1e2317"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M346.277,323.477H344.83a.181.181,0,0,1-.182-.182v-1.24a.182.182,0,0,1,.182-.182h1.447a.183.183,0,0,1,.182.182v1.24a.182.182,0,0,1-.182.182",
    fill: "#1e2317"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2050",
    "data-name": "Rectangle 2050",
    width: 7.056,
    height: 30.964,
    transform: "translate(270.926 309.331)",
    fill: "#cc8001"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2051",
    "data-name": "Rectangle 2051",
    width: 7.056,
    height: 30.964,
    transform: "translate(277.875 309.331)",
    fill: "#b26901"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2052",
    "data-name": "Rectangle 2052",
    width: 1.08,
    height: 5.768,
    transform: "translate(335.757 283.37)",
    fill: "#1e2317"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2053",
    "data-name": "Rectangle 2053",
    width: 1.08,
    height: 27.144,
    transform: "translate(335.757 289.138)",
    fill: "#293020"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2054",
    "data-name": "Rectangle 2054",
    width: 1.08,
    height: 9.382,
    transform: "translate(335.757 316.282)",
    fill: "#1e2317"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M330.375,334.736a6.47,6.47,0,0,1-6.463-6.463v-6.849h1.08v6.849a5.383,5.383,0,1,0,10.766,0v-2.608h1.08v2.608a6.47,6.47,0,0,1-6.463,6.463",
    fill: "#293020"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2055",
    "data-name": "Rectangle 2055",
    width: 1.08,
    height: 5.768,
    transform: "translate(320.356 283.37)",
    fill: "#1e2317"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2056",
    "data-name": "Rectangle 2056",
    width: 1.08,
    height: 27.144,
    transform: "translate(320.356 289.138)",
    fill: "#293020"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2057",
    "data-name": "Rectangle 2057",
    width: 1.08,
    height: 9.383,
    transform: "translate(320.356 316.281)",
    fill: "#1e2317"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_719",
    "data-name": "Path 719",
    d: "M314.973,334.736a6.47,6.47,0,0,1-6.463-6.463v-6.849h1.08v6.849a5.383,5.383,0,0,0,10.766,0v-2.608h1.08v2.608a6.47,6.47,0,0,1-6.463,6.463",
    fill: "#293020"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAndShare);
export default __webpack_public_path__ + "static/media/view-and-share.88e17650238d3c41998978e91e1e44d1.svg";
export { ForwardRef as ReactComponent };